import { render } from "./LogView.vue?vue&type=template&id=4dd30cc0"
import script from "./LogView.vue?vue&type=script&setup=true&lang=js"
export * from "./LogView.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Volumes/Projects/wp_all_repo/wp-content/plugins/debug-log-config-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/views/LogView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4dd30cc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4dd30cc0', __exports__)) {
    console.log('reload')
    api.reload('4dd30cc0', __exports__)
  }
  
  module.hot.accept("./LogView.vue?vue&type=template&id=4dd30cc0", () => {
    console.log('re-render')
    api.rerender('4dd30cc0', render)
  })

}


export default __exports__